// Constants
import { END_POINTS } from '@/constants/endpoint';

// Utils
import { handleActionError } from '@/utils/errorHandlers';

// Services
import { httpClient } from '@/services/http';

// Types
import { HttpMethod, RequestConfig } from '@/types';
import { Effect, pipe } from 'effect';

const getCustomToken = async (options?: { requestConfig?: RequestConfig }) =>
  Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: async () => {
          const response = await httpClient<{ token: string }>(
            END_POINTS.GET_CUSTOM_TOKEN,
            {
              method: HttpMethod.POST,
              ...options?.requestConfig,
            },
          );

          return response;
        },
        catch: (error) => handleActionError<{ token: string }>(error),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );

export { getCustomToken };
